export enum TenantFeatureToggle {
  DEVELOPER = 'DEVELOPER',
  CALENDAR = 'CALENDAR',
  WALKIN = 'WALKIN',
  /** @deprecated PDF export was removed; kept because the Postgres enum still contains it. */
  EXPORTBOOKING = 'EXPORTBOOKING',
  MULTIPLEBOOKEDTABLES = 'MULTIPLEBOOKEDTABLES',
  TABLEMANAGEMENT = 'TABLEMANAGEMENT',
  CLOSEDSOCIETY = 'CLOSEDSOCIETY',
  CUSTOMERUIV2 = 'CUSTOMERUIV2',
  FOOD_EVENTS = 'FOOD_EVENTS',
  SIDEBAR_MODAL = 'SIDEBAR_MODAL',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  MONTHLY_OVERVIEW = 'MONTHLY_OVERVIEW',
  CUSTOMER_PAGE = 'CUSTOMER_PAGE',
}
